import { useAtom } from "jotai/index";
import { memo } from "react";
import { canv } from "@/canv/global";
import { penToolMenuLineWidthAtom } from "@/interface/AppStore";
import { LINE_WIDTHS } from "@/interface/SideBar/PenMenu/constants";
import { SelectableItem } from "@/interface/SideBar/PenMenu/SelectableItem";
import styles from "./PenMenu.module.css";

export const PenWidthSelector = memo(() => {
    const [currentWidth, setCurrentWidth] = useAtom(penToolMenuLineWidthAtom);
    const penTool = canv.toolBox.TryGetToolByName("penTool");
    const handleClick = (width: number) => {
        setCurrentWidth(width);
        penTool?.setWidth(width);
    };

    return (
        <div className={styles.penToolSubMenuWidth}>
            {LINE_WIDTHS.map(({ width, styleHeight }) => (
                <SelectableItem
                    key={width}
                    isSelected={currentWidth === width}
                    onClick={() => handleClick(width)}
                    className={styles.penToolSubMenuWidthItem}
                    selectedClassName={styles.penToolSubMenuTopItemSelected}
                >
                    <div
                        className={styles.penToolSubMenuWidthLine}
                        style={{ height: styleHeight }}
                    />
                </SelectableItem>
            ))}
        </div>
    );
});
